import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { Form } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import Popup from 'components/common/popup/popup';
import SystemStatusService from 'services/systemStatusService';

const styles = {
  clearButton: {
    marginBottom: '.4rem',
    float: 'right'
  }
};

export default function SystemStatusFilter(props) {
  const [createdGreaterThan, setCreatedGreaterThan] = useState(props.filters && props.filters.createdGreaterThan ? props.filters.createdGreaterThan : '');
  const [createdLesserThan, setCreatedLesserThan] = useState(props.filters && props.filters.createdLesserThan ? props.filters.createdLesserThan : '');
  const [createdFilter, setCreatedFilter] = useState(props.filters && props.filters.createdFilter ? props.filters.createdFilter : '');
  const [infoGroupName, setInfoGroupName] = useState(props.filters && props.filters.infoGroupName ? props.filters.infoGroupName : '');
  const [infoTypeId, setInfoTypeId] = useState(props.filters && props.filters.infoTypeId ? props.filters.infoTypeId : '');
  const [groups, setGroups] = useState([]);
  const [types, setTypes] = useState([]);

  useAsyncEffect(async () => {
    setGroups(await SystemStatusService.API.getSystemStatusGroupNames());
    setTypes(await SystemStatusService.API.getSystemStatusInfoTypes());
  }, []);

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    if (props.onChange) {
      props.onChange({ createdFilter, infoGroupName, infoTypeId, createdGreaterThan, createdLesserThan });
    }
  };

  const renderClearButton = (states, setStates, label = 'Clear') => {
    var show = false;
    for (var i = 0; i < states.length; i++) {
      if (states[i] !== null && states[i].length > 0) {
        show = true;
      }
    }

    if (!show) {
      return null;
    }

    const clearStates = () => {
      for (var i = 0; i < states.length; i++) {
        setStates[i]('');
      }
    };

    return <Inputs.Button variant='hover-default' onClick={clearStates} style={styles.clearButton} label={label} />;
  };

  const renderCustomRange = () => {
    if (createdFilter !== 'customrange') return null;
    return (
      <>
        <Form.Group>
          <Form.Label>From:</Form.Label>
          <Inputs.Date value={createdGreaterThan} onChange={setCreatedGreaterThan} />
        </Form.Group>
        <Form.Group>
          <Form.Label>To:</Form.Label>
          <Inputs.Date value={createdLesserThan} onChange={setCreatedLesserThan} />
        </Form.Group>
      </>
    );
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='default' onClick={handleClose} iconClass='icons8-undo' label='Cancel' />
        <Inputs.Button variant='app' onClick={handleSubmit} iconClass='icons8-checkmark' label='Apply' />
      </>
    );
  };

  if (!props.show) {
    return null;
  }

  return (
    <Popup
      title='Select Filters'
      footer={renderFooter()}
      show={true}
      onClose={handleClose}
    >
      <Form>
        <Form.Group>
          <Form.Label>Created Date:</Form.Label>
          {renderClearButton([createdFilter], [setCreatedFilter], 'Clear')}
          <Inputs.Select placeholder='Please select value' value={createdFilter} onValueChange={setCreatedFilter}>
            <Inputs.Option value='today' label='Today' />
            <Inputs.Option value='yesterday' label='Yesterday' />
            <Inputs.Option value='lastweek' label='Last 7 days' />
            <Inputs.Option value='previousweek' label='Previous 7 days' />
            <Inputs.Option value='customrange' label='Custom Range' />
          </Inputs.Select>
        </Form.Group>
        {renderCustomRange()}

        <Form.Group>
          <Form.Label>Info Type Id:</Form.Label>
          {renderClearButton([infoTypeId], [setInfoTypeId], 'Clear')}
          <Inputs.Select placeholder='Please select value' value={infoTypeId} onValueChange={setInfoTypeId}>
            {types && types.map((item) =>
              <Inputs.Option value={item.typeId} key={item.typeId} label={item.typeName} />
            )}
          </Inputs.Select>
        </Form.Group>

        <Form.Group>
          <Form.Label>Group:</Form.Label>
          {renderClearButton([infoGroupName], [setInfoGroupName], 'Clear')}
          <Inputs.Select placeholder='Please select value' value={infoGroupName} onValueChange={setInfoGroupName}>
            {groups && groups.map((item) =>
              <Inputs.Option value={item.groupName} key={item.groupName} label={item.groupName} />
            )}
          </Inputs.Select>
        </Form.Group>

        {renderClearButton([createdFilter, infoTypeId, infoGroupName], [setCreatedFilter, setInfoTypeId, setInfoGroupName], 'Clear All')}
        <div style={{ clear: 'both' }}></div>
      </Form>
    </Popup>
  );
};